export const stringToArray = (value: string | undefined, defaultValue: string[]) => {
    if (value === undefined) {
        return defaultValue;
    }
    return value?.split(", ");
};
